<template>
  <div class="smart">
    <div class="container">
      <div class="row ">
        <div class="col-md-7 img-smart">
          <img
            class="main-img"
            src="../../../assets/img/sessions/simple.svg"
            alt=""
          />
        </div>
        <div class="col-md-5 text-smart">
          <h2>SIMPLE</h2>
          <p>
            We’ve spent months packing in all the core features of a video app
            (such as, Screen Sharing, Chat, Whiteboards) while at the same time
            focusing on making the product easy to use. And there is no download
            required.
          </p>
          <p>
            Available On:
            <img
              class="available-on"
              src="../../../assets/img/sessions/available.svg"
              alt=""
            />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Smart.vue"
};
</script>

<style lang="scss" scoped>
.smart {
  .img-smart {
    min-height: 452px;
    display: flex;
    align-items: center;
    position: relative;
    .main-img {
      max-width: 80%;
    }
  }
  .text-smart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-bottom: 15%;
    h2 {
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 44px;
      color: #474d52;
      margin-bottom: 5px;
    }
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
    }
    .available-on {
      height: 22px;
      width: 170px;
    }
  }
}
@media (max-width: 991px) {
  .main-img {
    margin: 0 auto;
  }
}
</style>
